module.exports = __webpack_public_path__ + "img/1Q3ZZZ6dr1BJkXKSQUgo2NS4K4Z_229ZH.b4cda1b5.png";